import { Injectable } from '@angular/core';
import { BaseStatus } from './status.class';

/**
 * Service to provide status to drawer components
 */
@Injectable({
  providedIn: 'root'
})
export class DrawerStatusService extends BaseStatus {}
